import { loaderCreator } from '@/services/loaderPlugin/_base'
import mixpanelUtil from '@/utils/mixpanel.utils.js'
import { CONSENT_TYPES, addToConsentCallbackStore } from '@/utils/cookieConsent'
import { localGetters } from '@/utils/abtest.utils'

export default loaderCreator(() => {
  addToConsentCallbackStore(CONSENT_TYPES.ANALYTICS, (hasConsent) => {
    if (!hasConsent) {
      mixpanelUtil.init({
        disable_persistence: true,
      })
      return
    }
    const additionalOptions = localGetters.canUseMixpanelLocalStorage() ? {
      persistence: 'localStorage',
    } : {}
    mixpanelUtil.init(additionalOptions)
  })
})
